import gql from 'graphql-tag';

export const fetchTenantLeasesQuery = gql(/* GraphQL */ `
  query FetchTenantLeases($tenantId: UUID!, $propertyId: UUID!) {
    tenant(tenantId: $tenantId, propertyId: $propertyId) {
      id
      leases {
        leaseId
        suiteId
        suite {
          id
          name
          floors {
            id
            index
            name
          }
        }
        source {
          sourceType
          sourceRelationshipType
          sourceRelationshipId
        }
      }
    }
  }
`);
